const ABSOLUTE_URL_REGEX = /^(?:https?:|data:|blob:)/i;

/**
 * Resolves a URL returned by the API against the origin the browser is using
 * (protocol, domain including subdomain, and port).
 * Absolute URLs are returned unchanged; relative paths such as
 * `/api/reportes/obtenerInforme/<file>` are appended to that origin, so they
 * follow the host in the address bar even behind a reverse proxy.
 */
export const resolveApiUrl = (url, origin = window.location.origin) => {
  if (!url || ABSOLUTE_URL_REGEX.test(url)) return url;

  const base = origin.replace(/\/+$/, '');
  const path = url.replace(/^\/+/, '');

  return `${base}/${path}`;
};
